module.exports = __webpack_public_path__ + "static/media/Alejandro.8f6c6aeb.jpg";